(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/filter-and-sort.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/filter-and-sort.js');

'use strict';

const {
  ReactButton: Button,
  ReactBottomSheet: {
    BottomSheet,
    BottomSheetFooter
  },
  ReactBadge: Badge
} = svs.ui;
const {
  useState,
  useRef,
  useMemo
} = React;
const {
  useFocusTrap
} = svs.components.lbUtils;
const {
  useSetSearchParams,
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  Sort,
  Filter
} = svs.components.casino_react.filterAndSort.components;
const bottomSheetState = {
  CLOSED: 'closed'
};
const label = 'Filtrera & sortera';
const FilterAndSort = _ref => {
  let {
    includeProviderFilters = true
  } = _ref;
  const [showModal, setShowModal] = useState(false);
  const {
    clearFilterParams
  } = useSetSearchParams();
  const searchParams = useSearchParams();
  const numberOfActiveFilters = useMemo(() => searchParams.categories.length + searchParams.providers.length + searchParams.tags.length, [searchParams]);
  const contentRef = useRef();
  const {
    releaseFocus,
    trapFocus
  } = useFocusTrap({
    refocus: true,
    onEscape: () => {
      releaseFocus();
      setShowModal(false);
    },
    ariaHiddenElements: ['#main-content', '.fixed-top-content']
  });
  const onBottomSheetStateChange = state => {
    if (state.state === bottomSheetState.CLOSED) {
      setShowModal(false);
      releaseFocus();
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(Button, {
    "aria-label": label,
    className: "casino-filter-and-sort__sort-button",
    iconPosition: "left",
    onClick: e => {
      e.preventDefault();
      setShowModal(true);
      if (contentRef.current) {
        trapFocus(contentRef.current);
      }
    },
    transparent: true
  }, label, numberOfActiveFilters > 0 && React.createElement(Badge, {
    bounce: true,
    className: "casino-filter-and-sort__filter-section-badge badge-casino",
    size: "small"
  }, numberOfActiveFilters)), React.createElement(BottomSheet, {
    behavior: "modal",
    className: "casino-filter-and-sort",
    disablePageContentSpacing: true,
    headerTitle: label,
    inverted: true,
    isFixed: true,
    isVisible: showModal,
    onStateChange: state => {
      onBottomSheetStateChange(state);
    }
  }, React.createElement("div", {
    ref: contentRef
  }, React.createElement(Sort, null), React.createElement(Filter, {
    includeProviders: includeProviderFilters
  }), React.createElement(BottomSheetFooter, {
    className: "casino-filter-and-sort__bottom-sheet-footer"
  }, React.createElement(Button, {
    "aria-label": "Rensa filter",
    block: true,
    inverted: true,
    onClick: () => {
      clearFilterParams();
      releaseFocus();
      setShowModal(false);
    },
    transparent: true
  }, "Rensa filter"), React.createElement(Button, {
    "aria-label": "Klar",
    block: true,
    onClick: () => {
      releaseFocus();
      setShowModal(false);
    }
  }, "Klar")))));
};
setGlobal('svs.components.casino_react.filterAndSort.FilterAndSort', FilterAndSort);

 })(window);